export const ERROR_TEXT = 'Выберите организацию из списка';

export const EMPTY_TEXT = 'Нет совпадений с существующими компаниями или ИП';